import Aos from "aos";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./index.scss";

function Education() {
  useEffect(() => {
    // document.title = "Gemological Education | Galaxy Gemological Institute";
    window.scrollTo(0, 0);
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div className="EducationPage">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/gemological-education"
        />
        <title>Gemological Education | Galaxy Gemological Institute</title>
        <meta
          name="description"
          content="GGI offers comprehensive gemological education programs that prepare you for a career in the jewelry industry. Learn about diamonds and colored stones, jewelry design!"
        />
      </Helmet>

      <div className="EducationSec">
        <div className="container innerEducationSec">
          <div className="layer">
            <div className="titleDiv margintb">
              <h1 className="title" data-aos="zoom-out-left">
                Introduction
              </h1>
              <p data-aos="fade-down">Galaxy Gemological Institute (GGI) is a premier gemological institution dedicated to setting new standards in the gemstone and jewelry industry. Our mission is to empower industry professionals and consumers alike by providing accurate, reliable, and comprehensive gemological services.

                </p><br/>

              <div className="contentLeft" data-aos="fade-left">
                <h4 data-aos="fade-right">Vision</h4>
                <p data-aos="fade-down">
                To be the leading authority in gemology, providing unparalleled knowledge and expertise.
                </p><br/>
                <h4 data-aos="zoom-out-right">Mission</h4>
                <p data-aos="fade-up">
                To elevate the industry by:<br/>
<p  style={{ color: 'black' }}>Sharing Knowledge:</p> Disseminating valuable insights into gem knowledge, grading techniques, and industry best practices.<br/>
<p style={{ color: 'black' }}>Enhancing Industry Standards:</p> Educating local manufacturers on international standards of jewelry manufacturing, fostering innovation and quality.<br/>
<p style={{ color: 'black' }}>Building Consumer Trust: </p>Empowering consumers through authentic identification and grading reports, ensuring transparency and confidence in the market.<br/>
<p style={{ color: 'black' }}>Advancing Gemological Science:</p> Continuously upgrading our laboratory facilities and human resources to stay at the forefront of technological advancements.

                </p>
              </div>
            </div>
            <img
              alt="EducationCertificate_lcugez.webp"
              src={
                "https://res.cloudinary.com/ggi/image/upload/v1637903422/gemological-educationCertificate_lcugez.webp"
              }
              data-aos="zoom-out-left"
            />
          </div>
        </div>
      </div>
      {/* </Helmet> */}
    </div>
  );
}

const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Education);
